import React from 'react';
import { Button } from '../catalyst-ui-kit/button';

export const NotFound: React.FC = () => {
  return (
    <div className="flex grow flex-col items-center justify-center px-4 py-6 text-center">
      <div className="flex max-w-md flex-col items-center gap-6">
        <div className="flex flex-col space-y-2">
          <h1 className="text-xl text-contentPrimary">Uh-Oh. Page doesn't exist.</h1>
        </div>
        <p className="text-contentSecondary">This page couldn't be found.</p>

        <div className="mt-4 flex flex-col space-y-3 sm:flex-row sm:space-x-4 sm:space-y-0">
          <Button href="/" color="blue">
            Return Home
          </Button>
        </div>
      </div>
    </div>
  );
};
